"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5776],{

/***/ 17812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1591);
/* harmony import */ var _styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59693);
/* harmony import */ var _ButtonBase__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41810);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93871);










var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      padding: 12,
      borderRadius: '50%',
      overflow: 'visible',
      // Explicitly set the default value to solve a bug on IE 11.
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__/* .alpha */ .Fq)(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        backgroundColor: 'transparent',
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -12,
      '$sizeSmall&': {
        marginLeft: -3
      }
    },

    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -12,
      '$sizeSmall&': {
        marginRight: -3
      }
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__/* .alpha */ .Fq)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__/* .alpha */ .Fq)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: 3,
      fontSize: theme.typography.pxToRem(18)
    },

    /* Styles applied to the children container element. */
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */

var IconButton = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function IconButton(props, ref) {
  var _props$edge = props.edge,
      edge = _props$edge === void 0 ? false : _props$edge,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ButtonBase__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(classes.root, className, color !== 'default' && classes["color".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(color))], disabled && classes.disabled, size === "small" && classes["size".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(size))], {
      'start': classes.edgeStart,
      'end': classes.edgeEnd
    }[edge]),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref
  }, other), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: classes.label
  }, children));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(styles, {
  name: 'MuiIconButton'
})(IconButton));

/***/ }),

/***/ 36166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17812);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50066);
/* harmony import */ var _components_Icons_BackIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2936);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "BackButton__StyledLink",
  componentId: "sc-18sathq-0"
})(["display:flex;cursor:pointer;p{margin-right:8px;}:hover{text-decoration:underline;}", " ", "{", "}"], function (p) {
  return (p === null || p === void 0 ? void 0 : p.$padding) && "padding: ".concat(p.$padding, ";");
}, function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$mobilePadding) && "padding: ".concat(p === null || p === void 0 ? void 0 : p.$mobilePadding, ";");
});
var StyledIconBtn = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
  displayName: "BackButton__StyledIconBtn",
  componentId: "sc-18sathq-1"
})(["padding:1px;position:relative;bottom:2px;"]);
var StyledText = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
  displayName: "BackButton__StyledText",
  componentId: "sc-18sathq-2"
})(["", "{", "}"], function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$hideTextOnMobile) && "display: none;";
});

var BackButton = function BackButton(_ref) {
  var prevPath = _ref.prevPath,
      linkText = _ref.linkText,
      padding = _ref.padding,
      mobilePadding = _ref.mobilePadding,
      beforeNavigation = _ref.beforeNavigation,
      preventNavigation = _ref.preventNavigation,
      className = _ref.className,
      hideTextOnMobile = _ref.hideTextOnMobile,
      afterNavigation = _ref.afterNavigation;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(StyledLink, {
    className: className,
    $padding: padding,
    $mobilePadding: mobilePadding,
    onClick: function onClick() {
      if (beforeNavigation) {
        beforeNavigation();
      }

      if (preventNavigation) return;

      if (prevPath) {
        router.push(prevPath);
      } else {
        router.back();
      }

      afterNavigation && afterNavigation();
    },
    role: "button",
    tabIndex: 0,
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter") {
        if (beforeNavigation) {
          beforeNavigation();
        }

        if (preventNavigation) return;

        if (prevPath) {
          router.push(prevPath);
        } else {
          router.back();
        }

        afterNavigation && afterNavigation();
      }
    },
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledIconBtn, {
      "aria-label": "\u05D7\u05D6\u05E8\u05D4 \u05DC\u05E2\u05DE\u05D5\u05D3 \u05E7\u05D5\u05D3\u05DD",
      role: "presentation",
      tabIndex: -1,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_components_Icons_BackIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledText, {
      variant: "body1",
      $hideTextOnMobile: hideTextOnMobile,
      children: linkText
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (BackButton);

/***/ }),

/***/ 85776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _material_ui_core_Box__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(50253);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(50029);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(282);
/* harmony import */ var _material_ui_core_Container__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(43832);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91315);
/* harmony import */ var common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1438);
/* harmony import */ var components_BackButton_BackButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36166);
/* harmony import */ var components_GenericButton_GenericButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92208);
/* harmony import */ var components_PurchasePage_Preview_Payment_bitHelpers__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(11966);
/* harmony import */ var components_PurchasePage_Preview_Payment_PaymentContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79625);
/* harmony import */ var components_PurchasePage_PurchaseContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33574);
/* harmony import */ var components_QuickPurchasePage_QuickPurchaseContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98968);
/* harmony import */ var components_Reusable_LoaderPopup__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34839);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67294);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85518);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(50066);
/* harmony import */ var _pages_payment__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(43050);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(85893);























var StyledWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(_material_ui_core_Container__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z).withConfig({
  displayName: "PurchaseSummaryPage__StyledWrapper",
  componentId: "sc-j8eb7d-0"
})(["display:flex;flex-direction:column;padding:76px 16px 40px 16px;gap:32px;", "{padding:108px 60px 60px 60px;gap:48px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledSummaryContainer = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PurchaseSummaryPage__StyledSummaryContainer",
  componentId: "sc-j8eb7d-1"
})(["border-radius:16px;border:1px solid var(--Light-Grey,#f7f7f7);max-width:1056px;min-height:200px;"]);
var StyledHeader = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PurchaseSummaryPage__StyledHeader",
  componentId: "sc-j8eb7d-2"
})(["position:relative;padding:0 16px;border-radius:16px;min-height:106px;", "{background-image:url(/yellow-header.svg);background-size:\"1056px 106px;\";background-repeat:no-repeat;padding:0 60px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledImg = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].img.withConfig */ .ZP.img.withConfig({
  displayName: "PurchaseSummaryPage__StyledImg",
  componentId: "sc-j8eb7d-3"
})(["position:absolute;left:0;z-index:-5;border-radius:16px;"]);
var StyledHeaderText = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PurchaseSummaryPage__StyledHeaderText",
  componentId: "sc-j8eb7d-4"
})(["display:flex;justify-content:space-between;align-items:center;padding-top:13px;", "{}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledPersonDetailsContainer = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PurchaseSummaryPage__StyledPersonDetailsContainer",
  componentId: "sc-j8eb7d-5"
})(["", "{display:flex;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var defaultText = "\n  color: var(--Black, var(--Primary-Black, #000));\n  text-align: right;\n  font-family: Speedee, NarkisBlock;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  margin: 0;\n  padding: 0;\n";
var StyledHeaderTitle = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
  displayName: "PurchaseSummaryPage__StyledHeaderTitle",
  componentId: "sc-j8eb7d-6"
})(["", " font-size:26px;font-weight:bold;", "{font-size:32px;}"], defaultText, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledHeaderInfo = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PurchaseSummaryPage__StyledHeaderInfo",
  componentId: "sc-j8eb7d-7"
})([""]);
var StyledTopLine = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "PurchaseSummaryPage__StyledTopLine",
  componentId: "sc-j8eb7d-8"
})(["", " font-size:20px;font-weight:bold;", "{font-size:26px;}"], defaultText, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledAmount = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "PurchaseSummaryPage__StyledAmount",
  componentId: "sc-j8eb7d-9"
})(["", " font-size:24px;font-weight:bold;", "{font-size:26px;}"], defaultText, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledCurrency = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "PurchaseSummaryPage__StyledCurrency",
  componentId: "sc-j8eb7d-10"
})(["", " font-size:20px;font-weight:bold;", "{font-size:20px;}"], defaultText, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledBottomLine = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "PurchaseSummaryPage__StyledBottomLine",
  componentId: "sc-j8eb7d-11"
})(["", " font-size:14px;", "{font-size:20px;}"], defaultText, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledPersonDetails = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PurchaseSummaryPage__StyledPersonDetails",
  componentId: "sc-j8eb7d-12"
})(["padding:16px;border-bottom:1px solid var(--Light-Grey,#f7f7f7);", "{border-bottom:none;padding:0 60px 16px 80px;margin-top:35px;&:first-child{border-left:2px solid var(--Light-Grey,#f7f7f7);}}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledPersonTitle = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "PurchaseSummaryPage__StyledPersonTitle",
  componentId: "sc-j8eb7d-13"
})(["", " font-size:20px;font-weight:bold;", "{font-size:24px;margin-bottom:16px;}"], defaultText, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledDetails = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "PurchaseSummaryPage__StyledDetails",
  componentId: "sc-j8eb7d-14"
})(["", " font-size:18px;", "{font-size:20px;}"], defaultText, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledEmail = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "PurchaseSummaryPage__StyledEmail",
  componentId: "sc-j8eb7d-15"
})(["", " font-size:14px;", "{font-size:18px;}"], defaultText, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledPaymentButtons = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PurchaseSummaryPage__StyledPaymentButtons",
  componentId: "sc-j8eb7d-16"
})(["padding:16px;", "{margin:60px 60px 0 60px;padding:0 0 60px 0;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledPaymentTitle = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "PurchaseSummaryPage__StyledPaymentTitle",
  componentId: "sc-j8eb7d-17"
})(["", " font-size:20px;font-weight:bold;margin-bottom:16px;", "{font-size:24px;}"], defaultText, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledButtonsContainer = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PurchaseSummaryPage__StyledButtonsContainer",
  componentId: "sc-j8eb7d-18"
})(["display:flex;flex-direction:column;gap:16px;", "{gap:24px;flex-direction:row;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z).withConfig({
  displayName: "PurchaseSummaryPage__StyledButton",
  componentId: "sc-j8eb7d-19"
})(["display:flex;justify-content:center;align-items:center;width:100%;height:48px;border-radius:8px;border:2px solid var(--Yellow,#ffbc0d);background:var(--White,#fff);&:hover{box-shadow:0px 4px 8px 0px rgba(45,45,45,0.16);background:#fff;}", "{width:296px;padding:10px 10px 10px 20px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledButtonHeText = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "PurchaseSummaryPage__StyledButtonHeText",
  componentId: "sc-j8eb7d-20"
})(["", " font-size:24px;font-weight:bold;"], defaultText);
var StyledBitButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z).withConfig({
  displayName: "PurchaseSummaryPage__StyledBitButton",
  componentId: "sc-j8eb7d-21"
})(["display:flex;width:100%;height:48px;padding:10px;justify-content:center;align-items:center;gap:8px;align-self:stretch;border-radius:8px;background:linear-gradient(180deg,#2b5586 0%,#3b96b1 100%);", "{width:296px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledBitText = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "PurchaseSummaryPage__StyledBitText",
  componentId: "sc-j8eb7d-22"
})(["", " color:var(--White,#FFF);font-size:20px;font-style:normal;font-weight:500;line-height:26px;"], defaultText);
var StyledButtonIcon = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].img.withConfig */ .ZP.img.withConfig({
  displayName: "PurchaseSummaryPage__StyledButtonIcon",
  componentId: "sc-j8eb7d-23"
})([""]);
var StyledButtonInner = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PurchaseSummaryPage__StyledButtonInner",
  componentId: "sc-j8eb7d-24"
})(["display:flex;gap:6px;align-items:center;"]);
var NoPaymentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PurchaseSummaryPage__NoPaymentWrapper",
  componentId: "sc-j8eb7d-25"
})(["text-align:right;"]);
var NoPaymentSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "PurchaseSummaryPage__NoPaymentSubtitle",
  componentId: "sc-j8eb7d-26"
})(["font-size:24px;line-height:30px;font-weight:400;text-align:right;"]);

var PurchaseSummaryPage = function PurchaseSummaryPage() {
  var isDesktop = (0,common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__/* .useIsDesktop */ .Ce)();

  var _useQuickPurchaseCont = (0,components_QuickPurchasePage_QuickPurchaseContext__WEBPACK_IMPORTED_MODULE_7__/* .useQuickPurchaseContext */ .Nr)(),
      setShowExitModal = _useQuickPurchaseCont.setShowExitModal,
      discount = _useQuickPurchaseCont.discount,
      quickPurchaseInputValues = _useQuickPurchaseCont.quickPurchaseInputValues,
      setshowStickyBottom = _useQuickPurchaseCont.setshowStickyBottom,
      priceAfterDiscount = _useQuickPurchaseCont.priceAfterDiscount;

  var amount = quickPurchaseInputValues.amount,
      RecipientName = quickPurchaseInputValues.RecipientName,
      RecipientMobilePhone = quickPurchaseInputValues.RecipientMobilePhone,
      RecipientEmail = quickPurchaseInputValues.RecipientEmail,
      SenderName = quickPurchaseInputValues.SenderName,
      SenderMobilePhone = quickPurchaseInputValues.SenderMobilePhone,
      SenderEmail = quickPurchaseInputValues.SenderEmail;

  var _usePurchaseContext = (0,components_PurchasePage_PurchaseContext__WEBPACK_IMPORTED_MODULE_6__/* .usePurchaseContext */ .AX)(),
      purchaseData = _usePurchaseContext.purchaseData,
      blessingMode = _usePurchaseContext.blessingMode,
      selectedGiftCard = _usePurchaseContext.selectedGiftCard,
      giftCardLoadAmount = _usePurchaseContext.giftCardLoadAmount,
      giftCardPrice = _usePurchaseContext.giftCardPrice,
      addPercentage = _usePurchaseContext.addPercentage,
      orderId = _usePurchaseContext.orderId,
      orderRecipientGuid = _usePurchaseContext.orderRecipientGuid,
      setPaymentInitiationId = _usePurchaseContext.setPaymentInitiationId,
      setTransactionSerialId = _usePurchaseContext.setTransactionSerialId;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(null),
      availablePayment = _useState2[0],
      setAvailablePayment = _useState2[1];

  var _usePaymentContext = (0,components_PurchasePage_Preview_Payment_PaymentContext__WEBPACK_IMPORTED_MODULE_5__/* .usePaymentContext */ .JL)(),
      setPaymentSteps = _usePaymentContext.setPaymentSteps;

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)();
  (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(function () {
    setshowStickyBottom(false);

    if (!purchaseData || !amount || !orderId) {
      router.push("/");
    }
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(function () {
    var getPaymentTypes = /*#__PURE__*/function () {
      var _ref = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var _yield$getPaymentPaym, data;

        return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0,api__WEBPACK_IMPORTED_MODULE_1__.getPaymentPaymentMethods)(orderId, react_device_detect__WEBPACK_IMPORTED_MODULE_11__/* .isChrome */ .i7 ? "chrome" : react_device_detect__WEBPACK_IMPORTED_MODULE_11__/* .isSafari */ .G6 ? "safari" : react_device_detect__WEBPACK_IMPORTED_MODULE_11__/* .isFirefox */ .vU ? "firefox" : react_device_detect__WEBPACK_IMPORTED_MODULE_11__/* .isOpera */ .f0 ? "opera" : react_device_detect__WEBPACK_IMPORTED_MODULE_11__/* .isEdge */ .un ? "edge" : "other browser", null);

              case 2:
                _yield$getPaymentPaym = _context.sent;
                data = _yield$getPaymentPaym.data;
                setAvailablePayment(data.body);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getPaymentTypes() {
        return _ref.apply(this, arguments);
      };
    }();

    getPaymentTypes();
  }, []);
  var allValuesFalse = (0,react__WEBPACK_IMPORTED_MODULE_10__.useMemo)(function () {
    return availablePayment && Object.values(availablePayment).every(function (value) {
      return value === false;
    });
  }, [availablePayment]);
  /**
   * This function will be called when a user selects a payment option
   */

  (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(function () {
    var storedData = localStorage.getItem(orderRecipientGuid);

    if (storedData) {
      var _JSON$parse = JSON.parse(storedData),
          expirationTime = _JSON$parse.expirationTime;

      var currentTime = new Date().getTime();

      if (currentTime > expirationTime) {
        localStorage.removeItem(orderRecipientGuid);
      }
    }
  }, []);

  var handlePaymentSelection = function handlePaymentSelection(paymentOption) {
    if (!paymentOption || !orderId) return;
    if (paymentOption === "creditCard") router.push("payment/creditCard");
    if (paymentOption === "apple/google") router.push("payment/wallet");
  };
  /**
   * Handling bit payment
   *
   *
   */


  var payBit = function payBit(transactionSerialId, paymentInitiationId) {
    (0,components_PurchasePage_Preview_Payment_bitHelpers__WEBPACK_IMPORTED_MODULE_19__/* .bitPay */ .iw)({
      transactionSerialId: transactionSerialId,
      paymentInitiationId: paymentInitiationId,
      onApproval: function () {
        var _onApproval = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
          return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  setLoading(true);
                  _context2.next = 4;
                  return (0,api__WEBPACK_IMPORTED_MODULE_1__.postPaymentPaymentDoneBit)({
                    paymentInitiationId: paymentInitiationId
                  });

                case 4:
                  setLoading(false);
                  setPaymentSteps(_pages_payment__WEBPACK_IMPORTED_MODULE_12__.PaymentSteps.SUCCESS);
                  _context2.next = 13;
                  break;

                case 8:
                  _context2.prev = 8;
                  _context2.t0 = _context2["catch"](0);
                  setLoading(false);
                  setPaymentSteps(_pages_payment__WEBPACK_IMPORTED_MODULE_12__.PaymentSteps.FAILURE);
                  console.log(_context2.t0);

                case 13:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[0, 8]]);
        }));

        function onApproval() {
          return _onApproval.apply(this, arguments);
        }

        return onApproval;
      }(),
      onCancel: function () {
        var _onCancel = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3() {
          return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.prev = 0;
                  setLoading(true);
                  _context3.next = 4;
                  return (0,api__WEBPACK_IMPORTED_MODULE_1__.postPaymentPaymentDoneBit)({
                    paymentInitiationId: paymentInitiationId
                  });

                case 4:
                  setLoading(false);
                  _context3.next = 11;
                  break;

                case 7:
                  _context3.prev = 7;
                  _context3.t0 = _context3["catch"](0);
                  setLoading(false);
                  console.log(_context3.t0);

                case 11:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, null, [[0, 7]]);
        }));

        function onCancel() {
          return _onCancel.apply(this, arguments);
        }

        return onCancel;
      }()
    });
  };

  var getBitPayment = /*#__PURE__*/function () {
    var _ref2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4() {
      var _yield$getPaymentGetB, data;

      return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              setLoading(true);
              _context4.next = 4;
              return (0,api__WEBPACK_IMPORTED_MODULE_1__.getPaymentGetBit)(orderId, react_device_detect__WEBPACK_IMPORTED_MODULE_11__/* .isChrome */ .i7 ? "chrome" : react_device_detect__WEBPACK_IMPORTED_MODULE_11__/* .isSafari */ .G6 ? "safari" : react_device_detect__WEBPACK_IMPORTED_MODULE_11__/* .isFirefox */ .vU ? "firefox" : react_device_detect__WEBPACK_IMPORTED_MODULE_11__/* .isOpera */ .f0 ? "opera" : react_device_detect__WEBPACK_IMPORTED_MODULE_11__/* .isEdge */ .un ? "edge" : "other browser");

            case 4:
              _yield$getPaymentGetB = _context4.sent;
              data = _yield$getPaymentGetB.data;
              setLoading(false);

              if (!isDesktop) {
                (0,components_PurchasePage_Preview_Payment_bitHelpers__WEBPACK_IMPORTED_MODULE_19__/* .savePaymentDataToLocalStorage */ .iB)(orderRecipientGuid, {
                  paymentData: data.body,
                  purchaseData: purchaseData,
                  selectedGiftCard: selectedGiftCard,
                  blessingMode: blessingMode,
                  giftCardLoadAmount: giftCardLoadAmount,
                  giftCardPrice: giftCardPrice,
                  addPercentage: addPercentage,
                  orderId: orderId,
                  orderRecipientGuid: orderRecipientGuid
                });
              }

              setTransactionSerialId(data.body.transactionSerialId);
              setPaymentInitiationId(data.body.paymentInitiationId);
              (0,components_PurchasePage_Preview_Payment_bitHelpers__WEBPACK_IMPORTED_MODULE_19__/* .loadBitCom */ .ZI)({
                isDesktop: isDesktop,
                orderRecipientGuid: orderRecipientGuid,
                paymentInitiationId: data.body.paymentInitiationId,
                transactionSerialId: data.body.transactionSerialId,
                isAndroid: react_device_detect__WEBPACK_IMPORTED_MODULE_11__/* .isAndroid */ .Dt,
                isIOS: react_device_detect__WEBPACK_IMPORTED_MODULE_11__/* .isIOS */ .gn,
                pay: payBit
              });
              _context4.next = 17;
              break;

            case 13:
              _context4.prev = 13;
              _context4.t0 = _context4["catch"](0);
              setLoading(false);
              console.log(_context4.t0);

            case 17:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 13]]);
    }));

    return function getBitPayment() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (!amount) return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.Fragment, {});
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(StyledWrapper, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_BackButton_BackButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          linkText: "\u05D7\u05D6\u05E8\u05D4",
          padding: "7px 0 0 0",
          mobilePadding: "18px 0 0 0",
          preventNavigation: true,
          beforeNavigation: function beforeNavigation() {
            return setShowExitModal(true);
          }
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(StyledSummaryContainer, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(StyledHeader, {
          children: [!isDesktop && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(StyledImg, {
            src: "/yellow-header-small.svg",
            width: "100%"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(StyledHeaderText, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(StyledHeaderTitle, {
              children: "\u05E1\u05D9\u05DB\u05D5\u05DD \u05E4\u05E8\u05D8\u05D9\u05DD"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(StyledHeaderInfo, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(StyledTopLine, {
                children: ["\u05E1\u05D4\u05F4\u05DB \u05DC\u05EA\u05E9\u05DC\u05D5\u05DD: ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(StyledCurrency, {
                  children: "\u20AA"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(StyledAmount, {
                  children: priceAfterDiscount || "0"
                })]
              }), discount > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(StyledBottomLine, {
                children: ["\u05DC\u05D0\u05D7\u05E8 \u05E9\u05D5\u05D5\u05D9 \u05D4\u05E0\u05D7\u05D4 \u05E9\u05DC ", discount || 0, "%"]
              })]
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(StyledPersonDetailsContainer, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(StyledPersonDetails, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(StyledPersonTitle, {
              children: "\u05DC\u05DE\u05D9 \u05D4\u05DE\u05EA\u05E0\u05D4"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(StyledDetails, {
              children: RecipientName || ""
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(StyledDetails, {
              children: RecipientMobilePhone || ""
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(StyledEmail, {
              children: RecipientEmail || ""
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(StyledPersonDetails, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(StyledPersonTitle, {
              children: "\u05D4\u05E4\u05E8\u05D8\u05D9\u05DD \u05E9\u05DC\u05D9"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(StyledDetails, {
              children: SenderName || ""
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(StyledDetails, {
              children: SenderMobilePhone || ""
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(StyledEmail, {
              children: SenderEmail || ""
            })]
          })]
        }), !allValuesFalse ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(StyledPaymentButtons, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(StyledPaymentTitle, {
            children: "\u05D1\u05D7\u05D9\u05E8\u05EA \u05D0\u05E4\u05E9\u05E8\u05D5\u05D9\u05D5\u05EA \u05DC\u05EA\u05E9\u05DC\u05D5\u05DD"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(StyledButtonsContainer, {
            children: [(availablePayment === null || availablePayment === void 0 ? void 0 : availablePayment.creditCard) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(StyledButton, {
              onClick: function onClick() {
                return handlePaymentSelection("creditCard");
              },
              "aria-label": "\u05EA\u05E9\u05DC\u05D5\u05DD \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05DB\u05E8\u05D8\u05D9\u05E1 \u05D0\u05E9\u05E8\u05D0\u05D9",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(StyledButtonInner, {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(StyledButtonIcon, {
                  src: "/credit-card-icon.svg"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(StyledButtonHeText, {
                  children: "\u05DB\u05E8\u05D8\u05D9\u05E1 \u05D0\u05E9\u05E8\u05D0\u05D9"
                })]
              })
            }), (availablePayment === null || availablePayment === void 0 ? void 0 : availablePayment.wallet) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(StyledButton, {
              onClick: function onClick() {
                return handlePaymentSelection("apple/google");
              },
              "aria-label": "\u05EA\u05E9\u05DC\u05D5\u05DD \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05D0\u05E8\u05E0\u05E7 \u05D3\u05D9\u05D2\u05D9\u05D8\u05DC\u05D9 \u05D2\u05D5\u05D2\u05DC \u05E4\u05D9\u05D9 \u05D0\u05D5 \u05D0\u05E4\u05DC \u05E4\u05D9\u05D9",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(StyledButtonInner, {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(StyledButtonIcon, {
                  src: "/pay-icon.svg"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(StyledButtonIcon, {
                  src: "/google-pay-icon.svg"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(StyledButtonIcon, {
                  src: "/icon-divider.svg"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(StyledButtonIcon, {
                  src: "/pay-icon.svg"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(StyledButtonIcon, {
                  src: "/apple-pay-icon.svg"
                })]
              })
            }), (availablePayment === null || availablePayment === void 0 ? void 0 : availablePayment.bit) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(StyledBitButton, {
              onClick: function onClick() {
                return getBitPayment();
              },
              "aria-label": "\u05EA\u05E9\u05DC\u05D5\u05DD \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05D1\u05D9\u05D8",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(StyledButtonInner, {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(StyledBitText, {
                  children: "\u05EA\u05E9\u05DC\u05D5\u05DD \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(StyledButtonIcon, {
                  src: "/bit-logo-icon.svg"
                })]
              })
            })]
          })]
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(NoPaymentWrapper, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(StyledPaymentTitle, {
            children: "\u05D0\u05D5\u05E4\u05E1\u05D9, \u05D0\u05D9 \u05D0\u05E4\u05E9\u05E8 \u05DC\u05D1\u05E6\u05E2 \u05E8\u05DB\u05D9\u05E9\u05D4 \u05DB\u05E8\u05D2\u05E2 \u05D1\u05D0\u05EA\u05E8"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(NoPaymentSubtitle, {
            children: "\u05D0\u05E0\u05D7\u05E0\u05D5 \u05E2\u05DC \u05D6\u05D4! \u05D1\u05D1\u05E7\u05E9\u05D4 \u05DC\u05E0\u05E1\u05D5\u05EA \u05E9\u05D5\u05D1 \u05D1\u05E7\u05E8\u05D5\u05D1"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_GenericButton_GenericButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            btnType: "filled",
            onClick: function onClick() {
              return router.push("/quick-purchase");
            },
            children: "\u05D1\u05D5\u05D0\u05D5 \u05E0\u05E0\u05E1\u05D4 \u05E9\u05D5\u05D1"
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_Reusable_LoaderPopup__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        isOpen: loading
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PurchaseSummaryPage);

/***/ })

}]);